import {storeToRefs} from 'pinia';
import {Configuration, ProfileEditionApi, type UpdateAboutSectionRequest} from '@api';
import {useInfosRequest} from '~/composables/useInfosRequest';
import type {IndustryExpertiseEditionItem} from '~/features/about/types/EditAboutSection';
import {useProfileStore} from '~/store/profileStore';

export const useProfileAbout = () => {
    const apiConfiguration = new Configuration({basePath: ''});
    const profileEditionApi = new ProfileEditionApi(apiConfiguration);

    const profileStoreRequest = useInfosRequest();
    const profileStore = useProfileStore();
    const {listAllIndustryExpertise, reloadIndustryExpertises} = profileStore;
    const {profile} = storeToRefs(profileStore);

    async function updateProfileAbout(request: UpdateAboutSectionRequest) {
        await profileEditionApi.updateAboutSection({profileId: profile.value!.profileId, updateAboutSectionRequest: request});
        await Promise.all([profileStore.getProfile(profileStoreRequest), reloadIndustryExpertises()]);
    }

    async function fetchAvailableIndustryExpertises(): Promise<IndustryExpertiseEditionItem[]> {
        const response = await listAllIndustryExpertise();
        if (response) {
            const availableIndustryExpertises = response.all;
            const sortedExpertises = availableIndustryExpertises.sort((a, b) => a.label.localeCompare(b.label));
            return sortedExpertises.map((item) => ({humanId: item.id, label: item.label}));
        }
        return [];
    }

    return {
        updateProfileAbout,
        fetchAvailableIndustryExpertises,
    };
};
